// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
  return (
    <section className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-code">404</h1>
        <p className="notfound-message">Oops! The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="notfound-home-btn">
          ⬅️ Back to Home
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
